import { render, staticRenderFns } from "./TopicPage.vue?vue&type=template&id=d582895e"
import script from "./TopicPage.vue?vue&type=script&lang=js"
export * from "./TopicPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports